import type { TOC } from '@ember/component/template-only';
import eq from 'ember-truth-helpers/helpers/eq';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';

export default <template>
  <div class='field'>

    <@form.BasicRadioGroup
      @title='Dialyse'
      @propertyName='dialysisType'
      @errorClass='left-aligned-validation-error-message'
      as |Group|
    >
      <div class='fields'>
        <div class='field'>
          <Group.Radio @label='Non' @value={{false}} />
        </div>
        <div class='field'>
          <Group.Radio @label='Hémodialyse' @value='hemodialysis' />
        </div>
        <div class='field'>
          <Group.Radio
            @label='Dialyse péritonéale'
            @value='peritoneal-dialysis'
          />
        </div>
      </div>
    </@form.BasicRadioGroup>

  </div>

  {{#if (eq @form.changeset.dialysisType 'hemodialysis')}}
    <div class='field'>

      <@form.Dropdown
        @propertyName='dialysisCareLocation'
        @labelName='Lieu de prise en charge'
        @translationKey='medical-history-changed-journal-event.dialysis-care-location'
        @isMandatory={{true}}
        as |dropdown|
      >
        <dropdown.Item @key='at-home' />
        <dropdown.Item @key='in-uad' />
        <dropdown.Item @key='in-udm' />
        <dropdown.Item @key='in-intensive-care' />
      </@form.Dropdown>

    </div>
  {{/if}}

  {{#if (eq @form.changeset.dialysisType 'peritoneal-dialysis')}}
    <div class='field'>

      <@form.Dropdown
        @propertyName='dialysisCareType'
        @labelName='Type de prise en charge'
        as |dropdown|
      >
        <dropdown.Item @key='DPCA' @value='DPCA' />
        <dropdown.Item @key='DPA' @value='DPA' />

      </@form.Dropdown>

    </div>
  {{/if}}

  {{#if @form.changeset.dialysisType}}
    <div class='field'>
      <@form.Date
        @labelName='Date de début de dialyse'
        @propertyName='dialysisStartDate'
      />
    </div>
  {{/if}}

  {{#if (eq @form.changeset.dialysisType 'hemodialysis')}}
    <div class='field'>

      <@form.Dropdown
        @propertyName='dialysisMachineType'
        @labelName='Type de machine utilisée'
        @translationKey='medical-history-changed-journal-event.dialysis-machine-type'
        as |dropdown|
      >
        <dropdown.Item @key='PHYSIDIA-S3' />
        <dropdown.Item @key='FRESENIUS-4008S' />
        <dropdown.Item @key='FRESENIUS-4008H' />
        <dropdown.Item @key='FRESENIUS-5008S' />
        <dropdown.Item @key='FRESENIUS-5008-CorDiax' />
        <dropdown.Item @key='FRESENIUS-6008' />
        <dropdown.Item @key='NIKKIS-DBB-05' />
        <dropdown.Item @key='B.-BRAU-Dialog-plus' />
        <dropdown.Item @key='NXSTAGE-System-One' />
        <dropdown.Item @key='NXSTAGE-Versi-HD' />
        <dropdown.Item @key='GAMBRO-PRISMAFLEX' />
        <dropdown.Item @key='NEXTKIDNEY-NEOKIDNEY' />
      </@form.Dropdown>

    </div>
  {{/if}}

  {{#if (eq @form.changeset.dialysisType 'peritoneal-dialysis')}}
    <div class='field'>

      <@form.Dropdown
        @propertyName='dialysisMachineType'
        @labelName='Type de machine utilisée'
        @translationKey='medical-history-changed-journal-event.dialysis-machine-type'
        as |dropdown|
      >
        <dropdown.Item @key='FRESENIUS-SLEEPSAFE-HARMONY' />
        <dropdown.Item @key='BAXTER-EXTRANEAL' />
        <dropdown.Item @key='BAXTER-DIANEAL' />
        <dropdown.Item @key='BAXTER-NUTRINEAL' />
        <dropdown.Item @key='BAXTER-PHYSIONEAL' />
      </@form.Dropdown>

    </div>
  {{/if}}
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
